const langAuthOktaIdx = {
	step_identify: {
		tag: 'auth.okta_idx.step_identify',
		fr: 'Identification',
		en: 'Identify',
	},
	step_1st_check: {
		tag: 'auth.okta_idx.step_1st_check',
		fr: 'Mot de passe',
		en: 'Password',
	},
	step_2nd_check: {
		tag: 'auth.okta_idx.step_2nd_check',
		fr: 'Vérification',
		en: 'Check',
	},
	available_steps_cancel: {
		tag: 'auth.okta_idx.available_steps_cancel',
		fr: 'Retour à la page de connexion',
		en: 'Back to sign-in page',
	},
	available_steps_select_authenticator_authenticate: {
		tag: 'auth.okta_idx.available_steps_select_authenticator_authenticate',
		fr: "Vérification à l'aide d'une autre méthode",
		en: 'Verification using another method',
	},
	select_authenticator_authenticate_title: {
		tag: 'auth.okta_idx.select_authenticator_authenticate_title',
		fr: "Sélectionnez une méthode d'authentification",
		en: 'Select an authentication method',
	},
	select_authenticator_authenticate_method_security_question: {
		tag: 'auth.okta_idx.select_authenticator_authenticate_method_security_question',
		fr: 'Question secrète',
		en: 'Secret question',
	},
	select_authenticator_authenticate_method_okta_password: {
		tag: 'auth.okta_idx.select_authenticator_authenticate_method_okta_password',
		fr: 'Mot de passe',
		en: 'Password',
	},
	select_authenticator_authenticate_method_okta_email: {
		tag: 'auth.okta_idx.select_authenticator_authenticate_method_okta_email',
		fr: 'Code envoyé par e-mail',
		en: 'Verification code send by e-mail',
	},
	select_authenticator_authenticate_method_phone_number: {
		tag: 'auth.okta_idx.select_authenticator_authenticate_method_phone_number',
		fr: 'Code envoyé par SMS',
		en: 'Verification code send by SMS',
	},
	challenge_authenticator_email_title: {
		tag: 'auth.okta_idx.challenge_authenticator_email_title',
		fr: 'Vérification par e-mail',
		en: 'E-mail verification',
	},
	challenge_authenticator_email_description: {
		tag: 'auth.okta_idx.challenge_authenticator_email_description',
		fr: "Nous avons envoyé un e-mail à l'adresse <strong>{{email}}</strong>. Pour continuer, saisissez le code reçu par mail ci-dessous.",
		en: 'We have sent an email to <strong>{{email}}</strong>. To continue, copy the code receive by mail below.',
	},
	challenge_authenticator_email_field_verification_code_is_invalid: {
		tag: 'auth.okta_idx.challenge_authenticator_email_field_verification_code_is_invalid',
		fr: 'Le code fait 6 chiffres',
		en: 'The code need to have 6 digits',
	},
	challenge_authenticator_email_field_error_PASSCODE_INVALID: {
		tag: 'auth.okta_idx.challenge_authenticator_email_field_error.api.authn.error.PASSCODE_INVALID',
		fr: 'Code non valide ou expiré. Veuillez réessayer',
		en: 'Invalid code or expired. Please try again',
	},
	challenge_authenticator_email_btn_submit: {
		tag: 'auth.okta_idx.challenge_authenticator_email_btn_submit',
		fr: 'Vérifier',
		en: 'Check',
	},
	challenge_authenticator_password_title: {
		tag: 'auth.okta_idx.challenge_authenticator_password_title',
		fr: 'Vérification par mot de passe',
		en: 'Password verification',
	},
	challenge_authenticator_password_description: {
		tag: 'auth.okta_idx.challenge_authenticator_password_description',
		fr: 'Veuillez saisir votre mot de passe ci-dessous',
		en: 'Please type your password in the field below',
	},
	challenge_authenticator_password_field_label_password: {
		tag: 'auth.okta_idx.challenge_authenticator_password_field_label_password',
		fr: 'Votre mot de passe',
		en: 'Your password',
	},
	challenge_authenticator_password_btn_submit: {
		tag: 'auth.okta_idx.challenge_authenticator_password_btn_submit',
		fr: 'Valider',
		en: 'Confirm',
	},
	challenge_authenticator_password_field_error_is_required: {
		tag: 'auth.okta_idx.challenge_authenticator_password_field_error_is_required',
		fr: 'Le mot de passe est requis',
		en: 'The password is mandatory',
	},
	challenge_authenticator_password_field_error_E0000004: {
		tag: 'auth.okta_idx.challenge_authenticator_password_field_error.errors.E0000004',
		fr: "Votre mot de passe n'est pas valide",
		en: 'Password is invalid',
	},
	challenge_authenticator_security_question_title: {
		tag: 'auth.okta_idx.challenge_authenticator_security_question_title',
		fr: 'Vérification par question secrète',
		en: 'Secret question verification',
	},
	challenge_authenticator_security_question_description: {
		tag: 'auth.okta_idx.challenge_authenticator_security_question_description',
		fr: 'Veuillez saisir la réponse à la question que vous aviez choisi',
		en: 'Please type your answer for the choose question below',
	},
	challenge_authenticator_security_question_field_anwser_is_required: {
		tag: 'auth.okta_idx.challenge_authenticator_security_question_field_anwser_is_required',
		fr: 'La réponse est requise',
		en: 'The answer is mandatory',
	},
	challenge_authenticator_security_question_field_anwser_error: {
		tag: 'auth.okta_idx.challenge_authenticator_security_question_field_anwser_error.authfactor.challenge.question_factor.answer_invalid',
		fr: 'Votre réponse ne correspond pas aux données que nous avons. Veuillez réessayer.',
		en: 'Your answer does not match the data we have. Please try again.',
	},
	challenge_authenticator_security_question_field_label_answer: {
		tag: 'auth.okta_idx.challenge_authenticator_security_question_field_label_answer',
		fr: 'Réponse',
		en: 'Answer',
	},
	challenge_authenticator_security_question_btn_submit: {
		tag: 'auth.okta_idx.challenge_authenticator_security_question_btn_submit',
		fr: 'Confirmer',
		en: 'Confirm',
	},

	authenticator_verification_data_email_title: {
		tag: 'auth.okta_idx.authenticator_verification_data_email_title',
		fr: 'Vérification par e-mail',
		en: 'E-mail verification',
	},
	authenticator_verification_data_email_description: {
		tag: 'auth.okta_idx.authenticator_verification_data_email_description',
		fr: 'Dès que vous êtes prêt, cliquez sur le bouton "Envoyer un e-mail" afin de recevoir le code de vérification sur votre adresse <strong>{{email}}</strong>.',
		en: 'Once you are ready, click the "Send Email" button to receive the verification code to your <strong>{{email}}</strong> address.',
	},
	authenticator_verification_data_email_btn_submit: {
		tag: 'auth.okta_idx.authenticator_verification_data_email_btn_submit',
		fr: 'Envoyer un e-mail',
		en: 'Send Email',
	},

	authenticator_verification_data_sms_title: {
		tag: 'auth.okta_idx.authenticator_verification_data_sms_title',
		fr: 'Vérification par SMS',
		en: 'SMS verification',
	},
	authenticator_verification_data_sms_description: {
		tag: 'auth.okta_idx.authenticator_verification_data_sms_description',
		fr: 'Dès que vous êtes prêt, cliquez sur le bouton "Envoyer un SMS" afin de recevoir le code de vérification sur votre n° de mobile <strong>{{phoneNumber}}</strong>.',
		en: 'Once you are ready, click the "Send SMS" button to receive the verification code to your <strong>{{phoneNumber}}</strong> address.',
	},
	authenticator_verification_data_sms_btn_submit: {
		tag: 'auth.okta_idx.authenticator_verification_data_sms_btn_submit',
		fr: 'Envoyer un SMS',
		en: 'Send SMS',
	},
	challenge_authenticator_sms_field_error_PASSCODE_INVALID: {
		tag: 'auth.okta_idx.challenge_authenticator_sms_field_error.api.authn.error.PASSCODE_INVALID',
		fr: 'Code non valide ou expiré. Veuillez réessayer',
		en: 'Invalid or expired code. Please try again',
	},
	challenge_authenticator_sms_field_error_is_required: {
		tag: 'auth.okta_idx.challenge_authenticator_sms_field_error_is_required',
		fr: 'Le code à 6 chiffres est requis',
		en: 'The 6 digits code is mandatory',
	},
	challenge_authenticator_sms_field_label_code: {
		tag: 'auth.okta_idx.challenge_authenticator_sms_field_label_code',
		fr: 'Saisissez le code reçu par SMS',
		en: 'Enter the code receive by SMS',
	},
	challenge_authenticator_sms_btn_submit: {
		tag: 'auth.okta_idx.challenge_authenticator_sms_btn_submit',
		fr: 'Vérifier',
		en: 'Verify',
	},
	error_cannot_login: {
		tag: 'auth.okta_idx.error_cannot_login',
		fr: "Impossible de vous identifier avec cette adresse e-mail. Si vous pensez qu'il s'agit d'une erreur, veuillez contacter le support à <a href='mailto:help@sienna-im.com' target='_blank'>help@sienna-im.com</a>",
		en: 'Unable to login to your account with this email address. If you think this is an error, please contact support at <a href="mailto:help@sienna-im.com" target="_blank">help@sienna-im.com</a>',
	},
	error_resend_activation: {
		tag: 'auth.okta_idx.error_resend_activation',
		fr: 'Si un compte activable correspond à l\'adresse {{email}}, vous allez recevoir un mail pour initialiser votre compte. Sinon, contactez le support à <a href="mailto:help@sienna-im.com" target="_blank">help@sienna-im.com</a>',
		en: 'If an account that can be activated matches the {{email}} address, you will receive an email to initialize your account. Otherwise, please contact support at <a href="mailto:help@sienna-im.com" target="_blank">help@sienna-im.com</a>',
	},
	error_btn_back_to_login: {
		tag: 'auth.okta_idx.error_btn_back_to_login',
		fr: "Retour à l'identification",
		en: 'Back to login',
	},

	reenroll_authenticator_password_title: {
		tag: 'auth.okta_idx.reenroll_authenticator_password_title',
		fr: 'Votre mot de passe a expiré',
		en: 'Your current password is expired',
	},
	reenroll_authenticator_password_description: {
		tag: 'auth.okta_idx.reenroll_authenticator_password_description',
		fr: 'Veuillez créer un nouveau mot de passe',
		en: 'Please create a new password',
	},
	reenroll_authenticator_password_label_new_password: {
		tag: 'auth.okta_idx.reenroll_authenticator_password_label_new_password',
		fr: 'Saisissez votre nouveau mot de passe',
		en: 'Type a new password',
	},
	btn_save: {
		tag: 'auth.okta_idx.btn_save',
		fr: 'Enregistrer',
		en: 'Save',
	},
	warning_resend_text: {
		tag: 'auth.okta_idx.warning_resend_text',
		fr: "Vous n'avez pas reçu de SMS ?",
		en: "You didn't receive any SMS?",
	},
	warning_resend_link: {
		tag: 'auth.okta_idx.warning_resend_link',
		fr: "L'envoyer à nouveau",
		en: 'Resend it',
	},
};

export default langAuthOktaIdx;
